import { render, staticRenderFns } from "./ServidorDetalhe.vue?vue&type=template&id=4b1d8908&scoped=true&"
import script from "./ServidorDetalhe.vue?vue&type=script&lang=js&"
export * from "./ServidorDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./ServidorDetalhe.vue?vue&type=style&index=0&id=4b1d8908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d8908",
  null
  
)

export default component.exports